import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import MachineSafetyDrawer from "./MachineSafetyDrawer";

export const DEVELOPMENT_LINK_ID = "51";

export default function MachineSafetyDrawerPreview() {
  const { group_code: groupCode = "dev", project_code: projectCode = "ese" } = useParams();

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        bgcolor: "#111827",
        backgroundImage: "linear-gradient(90deg, rgba(2,6,23,.18), rgba(2,6,23,.62)), url('/images/main_safe.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Stack spacing={0.8} sx={{ position: "fixed", left: { xs: 16, sm: 24 }, bottom: 22, zIndex: 1, color: "#fff", display: { xs: "none", md: "flex" } }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, letterSpacing: 0 }}>Machine Safety Drawer 개발 화면</Typography>
        <Stack direction="row" spacing={0.7}>
          <Chip size="small" label={`${groupCode}/${projectCode}`} sx={{ color: "#e2e8f0", bgcolor: "rgba(15,23,42,.78)" }} />
          <Chip size="small" label={`연동 ID ${DEVELOPMENT_LINK_ID}`} sx={{ color: "#c7d2fe", bgcolor: "rgba(79,70,229,.8)" }} />
        </Stack>
      </Stack>
      <MachineSafetyDrawer
        open
        variant="permanent"
        groupCode={groupCode}
        projectCode={projectCode}
        linkId={DEVELOPMENT_LINK_ID}
      />
    </Box>
  );
}
